import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    userError: '',
    rootUrl: 'https://wsrdv.openlab.ma/crcapi/',
    simulateur : {
      selectedModele : "0",
      selectedVersion: 0,
      selectedPeinture: "N",
      selectedApport: 0,
      apport: 0,
      remise : 0,
      montant : 0,
    }
  },
  mutations: {
    SET_USER_DATA (state, userData) {
      state.user = userData
      localStorage.setItem('user', JSON.stringify(userData))
      axios.defaults.headers.common['Authorization'] = `Bearer ${
          userData.jwt
      }`
    },
    SET_MONTANT (state, payload) {
      state.simulateur.montant = payload
    },
    SET_MODELE (state, payload) {
      state.simulateur.selectedModele = payload
    },
    SET_VERSION (state, payload) {
      state.simulateur.selectedVersion = payload
    },
    SET_PEINTURE (state, payload) {
      state.simulateur.selectedPeinture = payload
    },
    SET_APPORT (state, payload) {
      state.simulateur.selectedApport = payload
    },
    SET_REMISE (state, payload) {
      state.simulateur.remise = payload
    },
    SET_APPORTVALUE (state, payload) {
      state.simulateur.apport = payload
    },
    LOGOUT () {
      localStorage.removeItem('user')
      location.reload()
    }
  },
  actions: {
    login ({ commit }, credentials) {
      credentials.action = 'login'
      return axios
          .post(this.state.rootUrl+'apiSales.php', credentials,10000)
          .then(({ data }) => {
            commit('SET_USER_DATA', data.data)
          })
          .catch( error => {
            if(error.response.data == 'missing atelier mobile right'){
              this.state.userError = 'Vous n\'êtes pas un utilisateur Sales'
            }else {
              if (error.response.status == '403') {
                console.log('Oups utilisateur ou mot de passe invalide')
              }
            }
          })
    },
    logout ({ commit }) {
      commit('LOGOUT')
    },
  },
  modules: {
  },
  getters: {
    loggedIn (state) {
      return !!state.user
    }
  }
})
